export default function (category, action, context) {
    const data = {
        action: action,
        type: category,
        host: window.location.host,
        context: JSON.stringify(context),
        isMobile: DM.Config.isMobile
    };

    window._dmq && window._dmq.push(data);
}
